var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultimediaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "audio-video_icon",
    "data-name": "audio-video icon",
    transform: "translate(21571 -14040)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1300",
    "data-name": "Rectangle 1300",
    width: 32,
    height: 32,
    transform: "translate(-21571 14040)",
    fill: "#currentColor",
    opacity: 0.002
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5466",
    "data-name": "Group 5466",
    transform: "translate(-21568.389 14042.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M2.689,26.891H0V0H2.689V1.344H5.377V0H27.044V13.445H24.2V9.412a5.378,5.378,0,1,0-10.756,0v4.033H8.067v2.689a10.766,10.766,0,0,0,6.722,9.974v.78H5.377V25.545H2.689v1.344Zm0-6.723v2.689H5.377V20.168Zm0-5.379v2.689H5.377V14.789Zm0-5.377V12.1H5.377V9.412Zm0-5.379v2.69H5.377V4.033Zm16.137,12.1h0V9.412l0,6.72Z",
    transform: "translate(0 0)",
    fill: "#currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M10.067,7a2.689,2.689,0,0,1,2.689,2.689v6.722a2.689,2.689,0,0,1-5.378,0V9.689A2.689,2.689,0,0,1,10.067,7m8.067,9.411a8.078,8.078,0,0,1-6.722,7.959v2.8H8.722v-2.8A8.078,8.078,0,0,1,2,16.411H4.689a5.378,5.378,0,1,0,10.756,0h2.689",
    transform: "translate(8.756 -0.278)",
    fill: "#currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultimediaIcon);
export default __webpack_public_path__ + "static/media/multimediaIcon.a9008da54ffbc7ef00b0d0c1072270ee.svg";
export { ForwardRef as ReactComponent };